<template>
	<b-modal
		ref="postures-by-period-modal"
		size="xmd"
		hide-footer
		@hidden="handleCloseModal"
		scrollable
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">
					Posturas | Periodo:
					<span>{{ period.period_start | myGlobalDayShort }}</span>
					-
					<span v-if="period.period_end">{{ period.period_end | myGlobalDayShort }}</span>
					<span v-else>SIN FINALIZAR</span>
				</div>
				<div style="display: flex; gap: 0.5rem">
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-overlay :show="isLoading">
			<b-table-simple responsive sticky-header="60vh" no-border-collapse>
				<b-thead class="sticky-header" style="white-space: nowrap">
					<b-tr>
						<b-th v-for="field in fields" :key="field.key" :class="field.class">
							{{ field.label }}
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<template v-if="postures.length > 0">
						<b-tr v-for="(posture, index) in postures" :key="index">
							<b-td class="text-center">
								<SpecimenPlate :specimen="posture.madrilla" />
							</b-td>
							<b-td class="text-center">
								{{ posture.code }}
							</b-td>
							<b-td class="text-center">
								{{ posture.description.toUpperCase() }}
							</b-td>
							<b-td class="text-center">
								<span v-if="posture.start_date">
									{{ posture.start_date | myGlobalDayShort }}
								</span>
								<span v-else>-</span>
							</b-td>
							<b-td class="text-center">
								<span v-if="posture.end_date">
									{{ posture.end_date | myGlobalDayShort }}
								</span>
								<span v-else>-</span>
							</b-td>
						</b-tr>
					</template>
					<b-tr v-if="postures.length === 0">
						<b-td :colspan="fields.length" class="text-center">No hay registros para mostrar</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</b-overlay>
	</b-modal>
</template>

<script>
import PosturePeriodsService from "@/services/encaste/posturas/posture-periods.service.js"
import SpecimenPlate from "@/components/specimens/SpecimenPlate.vue"
export default {
	name: "PosturesByPeriodModal",
	props: {
		period: {
			type: Object,
			required: true,
		},
	},
	components: { SpecimenPlate },
	data: () => ({
		isLoading: false,
		fields: [
			{ key: "madrilla", label: "Madrilla", class: "text-center" },
			{ key: "code", label: "Código", class: "text-center" },
			{ key: "status", label: "ESTADO", class: "text-center" },
			{ key: "start_date", label: "ACTIVADO EN", class: "text-center" },
			{ key: "end_date", label: "FINALIZADO EN", class: "text-center" },
		],
		postures: [],
	}),
	computed: {},
	methods: {
		handleCloseModal() {
			this.$emit("refresh")
			this.$emit("close")
		},
		async getRows() {
			try {
				this.isLoading = true
				const { data } = await PosturePeriodsService.getPosturesByPeriod(this.period.id)
				this.postures = data || []
			} catch (error) {
				console.error("Error fetching average weights report drafts:", error)
			} finally {
				this.isLoading = false
			}
		},
	},

	async mounted() {
		await this.getRows()
		this.$refs["postures-by-period-modal"].toggle()
	},
}
</script>
